import PropTypes from 'prop-types';

const TypeCompte = ({ typesCompte }) => {
    const HERITIER = 'Héritier';
    return typesCompte
        .map((type) => (type === HERITIER ? "Détenteur d'armes héritées ou trouvées" : type))
        .join(', ');
};

TypeCompte.propTypes = {
    typesCompte: PropTypes.array.isRequired,
};

export default TypeCompte;
